import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Fa from 'react-fontawesome';

function TVPathRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  const tvField = data.tv_field;
  if (!tvField) {
    return (
      <span><code>{data.field_id}</code> <span className="label label-danger text-uppercase">TruVoice Field Not Found.</span></span>
    );
  }

  
  let description = null;
  if (tvField.definition && tvField.definition.length > 0) {
    const tip = (
      <Tooltip id={`data-tv-tip-${data._id}`}>
        <div>{tvField.definition}</div>
      </Tooltip>
    );
    description = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
        <Fa name="info-circle" className="text-active" />
      </OverlayTrigger>
    );
  }
  let activeCmp = null;
  if (tvField.active === false) {
    activeCmp = (<span className="label label-danger text-uppercase">Inactive</span>);
  }
  return (
    <span>
      <code>{tvField.parent}</code> <Fa className="text-muted" name="chevron-right" /> <code>{tvField.name}</code> <span className="label label-default text-uppercase">{tvField.dataName}</span> {activeCmp} {description}
    </span>
  );
}

TVPathRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    tv_field: PropTypes.shape({}),
  }).isRequired,
}
TVPathRenderer.defaultProps = {
}

export default TVPathRenderer;
